import * as yup from 'yup'

import { model } from 'services/model'

// neet to move to approptiate place and change import in actions file
const validationSchema = yup.object().shape({
  name: yup.string(),
  translations: yup.object().shape({
    EN: yup.string(),
    NO: yup.string(),
    UK: yup.string()
  }),
  eNumber: yup.string(),
  description: yup.string(),
  synonyms: yup
    .array()
    .of(
      yup.object().shape({
        _id: yup.string(),
        names: yup.object().shape({
          EN: yup.string(),
          NO: yup.string(),
          UK: yup.string()
        })
      })
    )
    .nullable(),
  productsIds: yup.array().of(yup.string()),
  children: yup.array().of(yup.object()),
  isLastLevel: yup.boolean().nullable(),
  isTopLevel: yup.boolean().nullable(),
  _path: yup.string().nullable()
})

const Receiver = model(
  'ingredient',
  {
    ...validationSchema.fields,
    translations: validationSchema.fields.translations.shape({
      EN: yup.string().default(''),
      NO: yup.string().default(''),
      UK: yup.string().default('')
    })
  },
  validationSchema
)

export default Receiver
